/* TUZEX: načíta ďalšie farby modelu podľa pravidla cez pomocnú šablónu vyhľadávania.
   Pravidlo: slová oddelené medzerou musia byť všetky v názve, alternatívy cez „|“ (napr. „essentials hoodie|mikiny“). */
(() => {
  if (customElements.get('tx-related-models')) return;
  const norm = (t) => ' ' + String(t || '').toLowerCase().replace(/[-()"'’,/.&+:]/g, ' ').replace(/\s+/g, ' ').trim() + ' ';
  const needle = (a) => {
    a = a.replace(/-/g, ' ').trim();
    if (!a) return null;
    if (a.includes(' ')) return ' ' + a;
    if (a.length >= 6) return ' ' + a.slice(0, a.length - 1);
    return ' ' + a + ' ';
  };
  const matcher = (pattern) => {
    const toks = String(pattern || '').toLowerCase().split(/\s+/).filter(Boolean).map((t) => t.split('|').map(needle).filter(Boolean));
    return (title) => { const t = norm(title); return toks.every((alts) => alts.some((n) => t.includes(n))); };
  };
  customElements.define('tx-related-models', class extends HTMLElement {
    connectedCallback() {
      if (this.started) return; this.started = true;
      const io = 'IntersectionObserver' in window ? new IntersectionObserver((e) => { if (e.some((x) => x.isIntersecting)) { io.disconnect(); this.load(); } }, { rootMargin: '400px' }) : null;
      if (io && this.parentElement) io.observe(this.parentElement); else this.load();
    }
    async load() {
      const track = this.querySelector('[data-tx-rel-track]');
      const max = Number(this.dataset.max) || 16, self = String(this.dataset.id);
      const match = matcher(this.dataset.pattern);
      const seen = new Set([self]); let added = 0;
      for (let page = 1; page <= 6 && added < max; page++) {
        let doc;
        try {
          const res = await fetch(this.dataset.url + '&view=txrel&page=' + page, { credentials: 'same-origin' });
          if (!res.ok) break;
          doc = new DOMParser().parseFromString(await res.text(), 'text/html');
        } catch (e) { break; }
        const box = doc.querySelector('[data-tx-rel-results]');
        if (!box) break;
        box.querySelectorAll('a.tx-rel__item').forEach((a) => {
          if (added >= max || seen.has(a.dataset.id) || !match(a.dataset.title)) return;
          seen.add(a.dataset.id); track.appendChild(document.importNode(a, true)); added++;
        });
        if (page >= (Number(box.dataset.pages) || 1)) break;
      }
      if (added > 0) this.hidden = false;
    }
  });
})();
